import { render, staticRenderFns } from "./groupSMSs.vue?vue&type=template&id=2e9ed35f&scoped=true&"
import script from "./groupSMSs.vue?vue&type=script&lang=js&"
export * from "./groupSMSs.vue?vue&type=script&lang=js&"
import style0 from "./groupSMSs.vue?vue&type=style&index=0&id=2e9ed35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9ed35f",
  null
  
)

export default component.exports